import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Avatar,
  Typography,
  TextField,
  Button,
  Paper,
  Divider,
  CircularProgress,
  Modal
} from "@mui/material";
import { FaUserEdit, FaLock } from "react-icons/fa";
import { motion } from "framer-motion";
import { buttonGuardar, Input, Texto, SubTitulodos, Icono, BoxPerfil, styleCarga } from "../Layouts/CustomStyles";
import { useGetUser, usePerfilUsuario } from "../Services/Perfil";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";

const getInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  const initials =
    parts.length === 1
      ? parts[0][0]
      : parts[0][0] + parts[parts.length - 1][0];
  return initials.toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 70%, 50%)`;
};

export const PaginaPerfil = () => {
  const { perfil, loading, error } = useGetUser(); // trae datos desde API
  const { updatePerfilUsuario, updatePassword } = usePerfilUsuario();
  const [perfilData, setPerfilData] = useState(null);
  const [passwords, setPasswords] = useState({
    actual: "",
    nueva: "",
    confirmar: "",
  });
   const [loadings, setLoadings] = useState(false);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    if (perfil) setPerfilData(perfil);
  }, [perfil]);

  const handleChangeUser = (e) => {
    setPerfilData({ ...perfilData, [e.target.name]: e.target.value });
  };

  const handleChangePassword = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSaveProfile = async () => {
     setLoadings(true);
        setEnviandoAlert(true);
    try {
    await updatePerfilUsuario(perfilData);
      setLoadings(false);
            setEnviandoAlert(false);
            setSuccessAlertOpen(true);
            setAlertMessage("Perfil actualizado correctamente");
    } catch (err) {
      console.error(err);
      setErrorAlertOpen(true);
            setEnviandoAlert(false);
            setAlertMessage(
                err || "Error al actualizar el perfil."
            );
            setLoadings(false);
    }
  };

  const handleSavePassword = async () => {
    if (passwords.nueva !== passwords.confirmar) {
        setErrorAlertOpen(true);
            setEnviandoAlert(false);
            setAlertMessage(
               "La nueva contraseña y confirmación no coinciden"
            );
     
      return;
    }
    setLoadings(true);
        setEnviandoAlert(true);
    try {
      const res = await updatePassword(passwords);
      setLoadings(false);
            setEnviandoAlert(false);
            setSuccessAlertOpen(true);
            setAlertMessage("Contraseña actualizada correctamente");
      setPasswords({ actual: "", nueva: "", confirmar: "" });
    } catch (err) {
      console.error(err);
       setErrorAlertOpen(true);
            setEnviandoAlert(false);
            setAlertMessage(
                err || "Error al actualizar la contraseña"
            );
            setLoadings(false);
    
    }
  };
  const initials = perfilData ? getInitials(perfilData.name) : "";



  if (loading) return  <Box display="flex" justifyContent="center" mt={4} sx={styleCarga}>
          <CircularProgress />
        </Box>;
  if (error) return <p>{error}</p>;

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Paper
          elevation={4}
          sx={{
            p: 4,
            borderRadius: "20px",
            background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          }}
        >
          {/* Cabecera de perfil */}
          <Box display="flex" alignItems="center" gap={3} mb={4}>
           <Avatar
  alt={perfilData?.name || ""}
  sx={{
    width: 100,
    height: 100,
    fontSize: 36,
    fontWeight: "bold",
    bgcolor: stringToColor(perfilData?.name || "Usuario"),
    color: "white",
    border: "3px solid #feffffff",
  }}
>
  {initials}
</Avatar>

            <Box>
              <Typography variant="h5" sx={Texto}>
                {perfilData?.name}
              </Typography>
              <Typography variant="body1" sx={SubTitulodos}>
                {perfilData?.rol_name}
              </Typography>
            </Box>
          </Box>
<Box sx={BoxPerfil}>
          {/* Datos del usuario */}
          <FaUserEdit style={Icono} />
          <Typography
            variant="h6"
            sx={Texto}
          >
             Información Personal
          </Typography>
</Box>
          <Grid container spacing={2}>
          {["name", "email"].map((field) => (
  <Grid item xs={12} sm={6} key={field}>
    <TextField
      label={
        field === "name"
          ? "Nombre Completo"
          : field === "email"
          ? "Correo Electrónico"
          : "Rol"
      }
      sx={Input}
      name={field}
      fullWidth
      value={perfilData?.[field] || ""}
      onChange={handleChangeUser}
    />
  </Grid>
))}

          </Grid>

          <Box textAlign="right" mt={3}>
            <Button
              variant="contained"
              sx={buttonGuardar}
              onClick={handleSaveProfile}
            >
              Guardar Cambios
            </Button>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={BoxPerfil}>
            <FaLock  style={Icono}/>
          <Typography
            variant="h6"
            sx={Texto}
          >
             Cambiar Contraseña
          </Typography>
</Box>
          <Grid container spacing={2}>
            {["actual", "nueva", "confirmar"].map((field, index) => (
              <Grid item xs={12} sm={4} key={field}>
                <TextField
                  label={
                    index === 0
                      ? "Contraseña Actual"
                      : index === 1
                      ? "Nueva Contraseña"
                      : "Confirmar Nueva"
                  }
                  sx={Input}
                  name={field}
                  type="password"
                  fullWidth
                  value={passwords[field]}
                  onChange={handleChangePassword}
                />
              </Grid>
            ))}
          </Grid>

          <Box textAlign="right" mt={3}>
            <Button
              variant="outlined"
              sx={buttonGuardar}
              onClick={handleSavePassword}
            >
              Actualizar Contraseña
            </Button>
          </Box>
        </Paper>
      </motion.div>
          <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '350px',
                        height: 'auto',
                        bgcolor: '#ffff',
                        boxShadow: 24,
                        p: 1,
                        borderRadius: '10px',
                        '@media (max-width: 500px)': {
                            width: '90%',
                        },
                    }}
                >
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: "-5px" }}>
                            {alertMessage}
                        </p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '350px',
                        height: 'auto',
                        bgcolor: '#ffff',
                        boxShadow: 24,
                        p: 1,
                        borderRadius: '10px',
                        '@media (max-width: 500px)': {
                            width: '90%',
                        },
                    }}
                >
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600' }}>
                            {alertMessage}
                        </p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '350px',
                        height: 'auto',
                        bgcolor: '#ffff',
                        boxShadow: 24,
                        p: 1,
                        borderRadius: '10px',
                        '@media (max-width: 500px)': {
                            width: '90%',
                        },
                    }}
                >
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#e83b33' }} />
                        <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: '20px' }}>
                            Procesando solicitud...
                        </p>
                    </section>
                </Box>
            </Modal>
    </Container>
  );
};
